// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__EnwS5","title":"styles_title__ysgOb","verboseLanguage":"styles_verboseLanguage__qRThi","container":"styles_container__imPSC"};